export default __webpack_public_path__ + "static/progress4-5f047994a8db941c55f07a86719d91a2.mp4";